(function () {
    function wrapButtonFace(button) {
        if (!button || button.dataset.filadelfiaFaceWrapped === 'true') {
            return;
        }

        var face = document.createElement('span');
        face.className = 'filadelfia-review-button__face';

        while (button.firstChild) {
            face.appendChild(button.firstChild);
        }

        button.appendChild(face);
        button.dataset.filadelfiaFaceWrapped = 'true';
    }

    function enhance(sectionElement) {
        if (!sectionElement) {
            return;
        }

        var buttons = sectionElement.querySelectorAll('.jm-action-buttons__button, .jm-button--primary, .jdgm-write-rev-link');
        buttons.forEach(wrapButtonFace);

        if (sectionElement._filadelfiaJudgeMeObserver) {
            return;
        }

        var observer = new MutationObserver(function () {
            var refreshedButtons = sectionElement.querySelectorAll('.jm-action-buttons__button, .jm-button--primary, .jdgm-write-rev-link');
            refreshedButtons.forEach(wrapButtonFace);
        });

        observer.observe(sectionElement, {
            childList: true,
            subtree: true
        });

        sectionElement._filadelfiaJudgeMeObserver = observer;
    }

    window.filadelfiaJudgeMe = {
        init: enhance
    };
})();
